import { render, staticRenderFns } from "./document-type-selector.vue?vue&type=template&id=35e8c416&lang=pug&"
import script from "./document-type-selector.vue?vue&type=script&lang=ts&"
export * from "./document-type-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports